var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("graficaAuxRHB")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2 btnBuscar elevation-2",attrs:{"tile":"","outlined":"","color":"indigo"},on:{"click":function($event){return _vm.verTabla()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-magnify")]),_vm._v(" ver tabla\n    ")],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab75fcc","hasScoped":true,"buble":{"transforms":{}}}!./src/components/Gestion/gestionRehabilitacion/graficaAuxiliar/graficaAuxiliar.html
// module id = 1095
// module chunks = 0